<template>
  <div style="width: 100vw;height: 100vh;">
            <img class="loginBackImg" src="../../assets/loginBack.png">
            <img class="loginLogo" src="../../assets/loginLogo.png">
    <div
        style="box-sizing: border-box;padding-left: 60px;padding-right:60px;margin-left: 46vw;width: 33vw;height: 100%;display: flex;flex-direction: column;justify-content: center;">

      <div class="login-type-tabs">
        <div
          v-for="item in loginTypes"
          :key="item.value"
          :class="{ 'login-type-item': true, active: form.type === item.value }"
          @click="form.type = item.value"
        >
          {{ item.label }}
        </div>
      </div>

      <div class="login-title">用户名</div>
      <input class="login-input" v-model="form.account_name"/>
      <div class="login-title" style="margin-top: 30px">密码</div>
      <input class="login-input" type="password" v-model="form.account_pwd"/>

      <div style="margin-top: 40px;position: relative">
        <div style="position: absolute;right: 0">
          <img @click="submit" src="../../assets/login-arrow.png" style="cursor: pointer;width: 3vw;height: auto">
        </div>

      </div>
      
      <!--            <div class="loginContentContainer">-->
      <!--                <div class="content">-->
      <!--                    <div class="left">-->
      <!--                        <div class="loginTitle">AM Arena</div>-->
      <!--                        <div class="loginInputView">-->
      <!--                            <el-input type="text" class="loginInput" placeholder="Email" v-model="form.account_name"></el-input>-->
      <!--                        </div>-->
      <!--                        <div class="loginInputView">-->
      <!--                            <el-input type="password" class="loginInput" placeholder="Password" v-model="form.account_pwd"></el-input>-->
      <!--                        </div>-->
      <!--                        <div class="loginInputView">-->
      <!--                            <el-select type="text" class="loginInput" placeholder="Identity" v-model="form.type" style="width:100%">-->
      <!--                                <el-option value="学生" label="Student"></el-option>-->
      <!--&lt;!&ndash;                                <el-option value="讲师" label="Lecturer"></el-option>&ndash;&gt;-->
      <!--&lt;!&ndash;                                <el-option value="助教" label="Teaching Assistant"></el-option>&ndash;&gt;-->
      <!--                            </el-select>-->
      <!--                        </div>-->
      <!--                        <div class="loginBtn" @click="submit">Login</div>-->
      <!--                    </div>-->
      <!--                    <div class="right">-->
      <!--                        <img src="../../assets/logo.png" class="logo">-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->

    </div>
  </div>
</template>

<script>
import {loginByContact, loginByStudent} from '../../api/index'
import {
  setUserId,
  setUserName,
  setUserType,
  getProjectCode,
  setApplicationExtraEvents,
  setAppId,
    setAccountName,
  setApplicationEvents, setAvatarUrl,logout
} from '../../utils/store'
import '../../assets/common/font.css'
export default {
  name: 'Login',
  data() {
    return {
      form: {
        account_name: '',
        account_pwd: '',
        type: '学生'
      },
      loginTypes: [
        { label: '学生', value: '学生' },
        { label: '老师', value: '讲师' }
      ]
    }
  },
  mounted() {
    //先清除一下数据
    logout()
  },
  methods: {
    submit() {
      if (!this.form.account_name) {
        this.$message.error('Please input email')
        return
      }

      if (!this.form.account_pwd) {
        this.$message.error('Please input password')
        return
      }

      if (this.form.type === '讲师') {
        loginByContact(this.form.account_name, this.form.account_pwd).then(res => {
          if (res.data.code == 0) {
            this.$message({
              message: 'login success',
              type: 'success'
            })
            const educatorName = (res.data.data.educator_first_name || res.data.data.contact_lastName || '') +
              (res.data.data.educator_last_name || res.data.data.contact_givenName || '')
            setUserId(res.data.data._id.$id)
            setUserName(educatorName)
            setUserType('educator')
            this.$router.push('/teacherawards')
          } else {
            this.$message.warning('login fail')
          }
        })
        return
      }

      loginByStudent(getProjectCode(), this.form.account_name, this.form.account_pwd).then(res => {
        if (res.data.code == 0) {
          this.$message({
            message: 'login success',
            type: 'success'
          })
          var result = res.data.data
          var application_extra_events= result.application_extra_events
          setApplicationExtraEvents(application_extra_events)
          var application_events= result.application_events
          setApplicationEvents(application_events)
          var app_id = result._id.$id
          setAppId(app_id)
          var account_name = result['student_info']['account_name']
          setAccountName(account_name)
          var avatar_url = result['student_info']['avatar_url']
          setAvatarUrl(avatar_url)
          setUserId(res.data.data.student_id)
          setUserType('student')
          var student_name = res.data.data.student_info.student_lastName + res.data.data.student_info.student_givenName
          setUserName(student_name)
          this.$router.push('/home')
        } else {
          this.$message.warning('Login failed: ' + res.data.msg)
        }
      })

    }
  }
}
</script>

<style lang="less">

.loginBackImg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
}

.loginLogo {
  width: 220px;
  position: absolute;
  z-index: 4;
  top: 100px;
  left: 150px;
}

.login-title {
  color: #FFFFFF;
  font-size: 0.728vw;
  font-weight: 400;
  font-family: "PingFang SC";
}
.login-input {
  margin-top: 2px;
  box-sizing: border-box;
  border: 0px solid transparent;
  border-bottom-width: 2px;
  border-bottom-color:#fff;
  color: #FFFFFF;
  font-size: 1.1vw;
  width: 100%;
  height: 3vw;
  background-color: transparent;
  outline: none;
  border-radius: 0px;
  padding: 0 15px;
}

.login-type-tabs {
  display: flex;
  margin-bottom: 28px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 4px;
  overflow: hidden;
}

.login-type-item {
  flex: 1;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: rgba(255, 255, 255, 0.82);
  cursor: pointer;
  font-size: 14px;
  font-family: "PingFang SC";
}

.login-type-item.active {
  color: #00348b;
  background: #fff;
  font-weight: 600;
}

.el-select-dropdown__item.selected {
  color: rgb(243, 152, 0);
  font-weight: 700;
}

.loginContainer {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .loginBackImg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -2;
    top: 0;
    left: 0;
  }

  .loginContentView {
    width: 70%;
    height: 70%;
    background: rgba(255, 255, 255);
    border-radius: 28px;
    position: relative;

    .loginContentContainer {
      width: 100%;
      position: absolute;
      z-index: 3;

      .content {
        display: flex;
        width: 90%;
        margin: 0 auto;

        .left {
          width: 50%;
          position: relative;

          .loginTitle {
            font-size: 4vh;
            margin-top: 10vh;
            text-align: center;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #002A38;
          }

          .loginInputView {
            margin: 5vh auto;
            width: 72%;
          }

          .loginBtn {
            width: 72%;
            height: 5vh;
            line-height: 5vh;
            text-align: center;
            margin: 6vh auto;
            background: #E74646;
            border-radius: 10px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
            font-size: 2vh;
            cursor: pointer;
          }

          .loginBtn:hover {
            opacity: 0.8;
          }

          .el-input__inner {
            border-radius: 10px !important;
            /* border: none; */
            height: 5vh;
            line-height: 5vh;
            font-size: 2vh;
            padding: 0 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #888888;
          }

          .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: rgb(243, 152, 0);
            outline: 0;
          }

          .el-input__icon {
            line-height: 5vh;
          }
        }

        .right {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          .logo {
            width: 60%;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }

    .loginContentImg {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
    }
  }
}

</style>
